/* eslint-disable import/prefer-default-export */
export const faultAnalysisStoreAction = {
  OPEN_POPUP: 'openFaultAnalysisPopup',
  CLOSE_POPUP: 'closeFaultAnalysisPopup',
};



// WEBPACK FOOTER //
// ./src/constants/fault-analysis.js